import { render, staticRenderFns } from "./modalVerReferencias.vue?vue&type=template&id=5e2ce4e4&"
import script from "./modalVerReferencias.vue?vue&type=script&lang=js&"
export * from "./modalVerReferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2ce4e4')) {
      api.createRecord('5e2ce4e4', component.options)
    } else {
      api.reload('5e2ce4e4', component.options)
    }
    module.hot.accept("./modalVerReferencias.vue?vue&type=template&id=5e2ce4e4&", function () {
      api.rerender('5e2ce4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalVerReferencias.vue"
export default component.exports